/**
 *
 * @description Function that builds a media query string for the sizes prop of an Image component
 *
 * @param mobile - The default size (mobile) in vw
 * @param desktop - The size for desktop in vw (min-width: 1024px)
 * @param extraWide - The size for extra wide screens in vw (min-width: 2560px)
 *
 * @usage Go for a size too big rather than too small
 *
 */

const sizes = (mobile: number, desktop?: number, extraWide?: number) => {
  const queries = [`(max-width: 1024px) ${mobile}vw`];

  if (desktop) {
    // remember to update this to the max-width of the site
    // if it ever changes to a fixed size below 100 %
    queries.push(`${"(max-width: 2560px)"} ${desktop}vw`);
  }

  if (extraWide) {
    queries.push(`${extraWide}vw`);
  }

  return queries.join(", ");
};

export default sizes;
